// `topBlockedBy`/`topBlocking` issue node derived from the shared `IssueSecondaryNode`, regenerated by
// `npm run sync`. The consuming component (`DependencyIssue`) narrows it via `Pick`.
import type {IssueSecondaryNode} from '../../issue-viewer-secondary-query-types'

export const BLOCKED_BY_CONNECTION_PATH = ['topBlockedBy']
export const BLOCKING_CONNECTION_PATH = ['topBlocking']

export type DependencyIssueNode = NonNullable<NonNullable<IssueSecondaryNode['topBlockedBy']['nodes']>[number]>
export type DependencyIssueRepositoryNode = NonNullable<DependencyIssueNode['repository']>
